import type { FaireProductEntity } from "../../entity_types/product";

export const p_s2gdpscpqt: FaireProductEntity = {
  token: "p_s2gdpscpqt",
  type: "product",
  name: "I ❤️ Cowboys Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/36a1d4e1e30ff61630c1fa0d417e82d339fe830eccccda98d07ca9e5dd641e65.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e263607e4d5cc704870ef66630d30c80e9f563e556cf8f985ddaf8e076ee9873.jpeg",
    "https://cdn.faire.com/fastly/37bf723321c5cea2bb4f87496cf4058c149f393bfd54c99a07e37ee1a51d5a50.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/83354ff7a37fc6c4a6fabca32c7225ad524cb8e3e1eb903ee260eed9dd7fb2d1.jpeg",
    "https://cdn.faire.com/fastly/62cb72c08411a28db5b022dea5e5091c4113043ba565a0b77303f207fb5a7f22.jpeg"
  ],
  priceDollars: 6.75,
  description: "Limited Availability - Will Not Restock\n\nThere's somethin' about those sun-baked, dusty ass hotties with a slight drawl and a big 'ol hat that gets the jimmies a rustlin'. Hop on into these socks and ride 'em into the sunset knowing you're being as truthful as you are comfortable.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:51.066Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
